import { Line } from "../../models/shapes/Line";
import { Point } from "../../models/Point";

/**
 * Функция находит крайние точки двух отрезков
 * @param {Line} seg1 - первый отрезок
 * @param {Line} seg2 - второй отрезок
 */

export function findMaxMinPoints(seg1: Line, seg2: Line) {
    const p1 = seg1.start;
    const p2 = seg1.end;
    const p3 = seg2.start;
    const p4 = seg2.end;

    const minX = Math.min(p1.x, p2.x, p3.x, p4.x);
    const maxX = Math.max(p1.x, p2.x, p3.x, p4.x);

    const minY = Math.min(p1.y, p2.y, p3.y, p4.y);
    const maxY = Math.max(p1.y, p2.y, p3.y, p4.y);

    return {
        min: new Point(minX, minY),
        max: new Point(maxX, maxY),
    }
}
